// AuthGate — wrappt geschützte Routes. Wenn nicht eingeloggt → /login.
//
// V1-Verhalten: useAuth liefert `session`. Solange `loading`, zeigen wir nichts
// (verhindert Login-Flash beim Reload mit gültiger Session im Storage).

import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/hooks/use-auth';

interface AuthGateProps {
  children: ReactNode;
}

export function AuthGate({ children }: AuthGateProps) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="grid min-h-dvh place-items-center text-sm text-neutral-500">
        <span className="tabular">Lade Session…</span>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
